import { apiRequest } from "@/services/api-client";
import { ListItemDecksOutput, WebAppRoutes } from "types/web-app";

export const listItemDecks = () =>
  apiRequest<ListItemDecksOutput>("/" + WebAppRoutes.LIST_ITEM_DECKS);
